export default "__VITE_ASSET__2e9bf254__"